var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.breadCrumbs)?_c('v-breadcrumbs',{staticClass:"pa-0",attrs:{"items":_vm.breadCrumbs},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-breadcrumbs-item',{staticClass:"text-subtitle-2 crumb-item",attrs:{"exact":"","to":item.to,"divider":"/"}},[_vm._v(" "+_vm._s(item.text)+" ")])]}}],null,false,2218532554)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }